import { FC } from 'react';
import * as R from 'ramda';
import { Connection, Handle, NodeProps, Position } from 'react-flow-renderer';
import Node, { contentStyle as style } from './Node';
import { Badge, Box } from '@mui/material';

const isValidConnection = (connection: Connection) => {
  return R.split('_', connection.target as string)[0].substring(0, 8) === 'campanha';
};


export const InicioNode: FC<NodeProps> = ({ data, selected, }) => {
  return (
    <Badge badgeContent={data.erros | 0} color="error">
      <Node
        label='Inicio'
        icon='play_circle'
        selected={selected}
        color={'#F2F2F2'}
        content={
          <Box style={style.io}>
            {data.label}
            <Handle
              type='source'
              position={Position.Right}
              id='o__data'
              style={{ ...style.handle, ...style.right }}
              isValidConnection={isValidConnection}
            />
          </Box>
        }
      />
    </Badge>
  );
};


